import React from 'react';
import Modal from '@roo/roo/Modal';
import { getGrayStateByToken, GRAY_AB_TOKEN } from '@utils/grayAB';
import { getStorage, setStorage } from '@utils/localStorage';
import * as Ids from '@utils/ids';

const CACHE_KEY = 'orderAutoCompleteRemindPoiList';

/** 订单系统完单方案优化新功能引导提示 */
const orderAutoCompleteTipsRemind = () => {
    const cachedPoiList = getStorage(CACHE_KEY) || '';
    const wmPoiId = Ids.getWmPoiId();
    if (
        wmPoiId !== '-1' &&
        cachedPoiList.indexOf(`${wmPoiId},`) === -1 &&
        getGrayStateByToken(GRAY_AB_TOKEN.ORDER_AUTO_COMPLETE_TIPS)
    ) {
        Modal.confirm({
            title: '订单自动完成规则说明',
            children: (
                <div>
                    <p>
                        1.
                        现有规则中，如果没有配送完成信息系统自动完成订单后，导致出现用户未实际收到商品而订单完成的投诉，造成了很差的体验和影响。因此，出于保障用户的合法权益、维护平台正常的交易秩序，对现有的系统完单时间做出相应延长。
                    </p>
                    <p>
                        2.
                        新规则中，当您的订单在没有配送完成信息或者配送出现异常时，系统将延长订单完成的时间，从而可能会影响您部分订单的结算周期，请您即时关注。
                    </p>
                    <p>
                        3.
                        订单被延长完成时间后，将在商家端订单信息中有对应提示，具体延长时间以订单提示信息为准。
                    </p>
                </div>
            ),
            showCancelButton: false,
            confirmText: '我知道了',
        });
        setStorage(CACHE_KEY, `${cachedPoiList}${wmPoiId},`);
    }
};

export default orderAutoCompleteTipsRemind;
